import React, { Component } from "react";
import {Modal } from "react-bootstrap";

import ModalDetailPanel from "./ModalDetailPanel";
import ModalAlertPanel from "../ModalAlertPanel";
import ModalActionMenuPanel from "./ModalActionMenuPanel";

export default class ModalGridMenu extends Component 
{

    render() {
        //console.log("props.modalType:" + this.props.modalType);
        var body;
        if (this.props.modalType=== "gridmenu") 
        {
            body = <ModalActionMenuPanel
                        readOnly={this.props.readOnly}
                        modalType={this.props.modalType}
                        onDetailViewRequest={this.props.onDetailViewRequest}
                        onRepostTagRequest={this.props.onRepostTagRequest}
                        onReprintTagsRequest={this.props.onReprintTagsRequest}
                        onResendNotificationsRequest={this.props.onResendNotificationsRequest}
                        onVoidRequest={this.props.onVoidRequest}
                        onMarkCompleteRequest={this.props.onMarkCompleteRequest}
                        onLogViewRequest={this.props.onLogViewRequest}
                        onCloseMenuRequest={this.props.onCloseMenuRequest}
                        onQuarantinePageRequest = {this.props.onQuarantinePageRequest}
                        onAddReceiptPageRequest = {this.props.onAddReceiptPageRequest}
            />
        } else if (this.props.modalType === "gridlayout")
        {
            body = <ModalActionMenuPanel
                        readOnly={this.props.readOnly}
                        modalType={this.props.modalType}
                        onSaveLayoutRequest = {this.props.onSaveLayoutRequest}
                        onResetLayoutRequest = {this.props.onResetLayoutRequest}
                        onRestoreLayoutRequest = {this.props.onRestoreLayoutRequest}
                        onCloseMenuRequest={this.props.onCloseMenuRequest}
            />

        } else if (this.props.modalType === "detail"){
            body = <ModalDetailPanel
                readOnly={this.props.readOnly}
                source="receipt"
                currentReceipt = {this.props.currentReceipt}
                onCancel={this.props.onHide}
            />
        } else if (this.props.modalType === "log"){
            body = <ModalDetailPanel
                readOnly={this.props.readOnly}
                userSession = {this.props.userSession}
                source="log"
                currentReceipt = {this.props.currentReceipt}
                onCancel={this.props.onHide}
            />
        } else if (this.props.modalType === "alert")
        {
            body = <ModalAlertPanel
                        readOnly={this.props.readOnly}
                        iconType = {this.props.alertIconType}
                        title = {this.props.alertTitle}
                        message = {this.props.alertMessage}
                        onCancel={this.props.onHide}
                    />
        }



        return (
            
            <Modal
                id="gridmodal"
                show={this.props.show}
                onHide={this.props.onHide}
            >
                <div className="modal-content">
                    {body}
                </div>
            </Modal>
        );
    }
}
